namespace PresignedConstants {
  export const MAX_FILE_SIZE = 1024 * 1024 * 20; // 20 MB
  export const EXPIRES = 3600; // 1 hour
  export const MAX_URI_LENGTH = 4096;
  export const MAX_FOLDER_NAME_LENGTH = 256;
}

export default PresignedConstants;
